import { Tooltip } from "@jugl-web/ui-kit";
import { cx, useTranslations } from "@jugl-web/utils";
import React from "react";

const NO_DETECTED_TOPICS = ["no conversation detected", "no request detected"];

const isNoDetectedTopic = (topic: string) =>
  NO_DETECTED_TOPICS.includes(topic.toLowerCase());

export const VoiceConversationTopicPill: React.FC<{
  topic?: string | null;
  disableTooltip?: boolean;
}> = ({ topic, disableTooltip }) => {
  const { t } = useTranslations();

  if (!topic) {
    return null;
  }

  const isFallbackTopic = isNoDetectedTopic(topic);

  return (
    <Tooltip
      isDisabled={disableTooltip}
      renderTrigger={({ ref, props }) => (
        <div
          ref={ref}
          {...props}
          className={cx(
            "flex h-6 max-w-max items-center justify-center rounded-md px-2 font-secondary text-[13px] text-dark ring-1 ring-white transition ring-inset",
            isFallbackTopic ? "bg-[#FCF6F0]" : "bg-[#F1F1FF]",
            !disableTooltip && "hover:ring-dark-700"
          )}
        >
          <span className="truncate">{topic}</span>
        </div>
      )}
    >
      {t(
        {
          id: "client-support-page.voice-last-topic",
          defaultMessage: "Last topic: {topic}",
        },
        { topic: <span className="font-bold">{topic}</span> }
      )}
    </Tooltip>
  );
};
